export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20boutique%20interior%20with%20soft%20beige%20and%20cream%20toned%20clothing%20displayed%20on%20minimalist%20wooden%20shelving%2C%20gentle%20ambient%20lighting%20from%20pendant%20lamps%2C%20calm%20serene%20retail%20atmosphere%2C%20organic%20textures%20of%20linen%20and%20cotton%20fabrics%2C%20clean%20aesthetic%20with%20natural%20elements%20and%20cozy%20sophisticated%20vibe&width=1440&height=600&seq=cta-final-v2&orientation=landscape"
          alt="Sugargoo spreadsheet shopping ready to explore curated fashion collections"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
          Ready to Find Better Products?
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-50/80 max-w-lg mx-auto leading-relaxed">
          Explore our complete Sugargoo spreadsheet resources and discover curated product collections, verified sellers, and smart shopping strategies.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-foreground-950 font-semibold text-sm hover:bg-background-100 transition-all duration-200 whitespace-nowrap"
          >
            Visit Main Website
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}